module.exports = __webpack_public_path__ + "static/media/hack_10_bg.08177b4a.jpg";